<template>
	<RegisteredPageLayout :loading="loading" :error="error">
		<template #header>
			<nav class="page-nav">
				<router-link :to="{ name: 'Instruction' }" :class="['nav-link', { active: $route.name === 'Instruction' }]">
					Instruction
				</router-link>
				<router-link :to="{ name: 'UserWireguard' }" :class="['nav-link', { active: $route.name === 'UserWireguard' }]">
					Wireguard
				</router-link>
				<router-link :to="{ name: 'UserSocks' }" :class="['nav-link', { active: $route.name === 'UserSocks' }]">
					SOCKS
				</router-link>
				<router-link :to="{ name: 'UserMTProxy' }" :class="['nav-link', { active: $route.name === 'UserMTProxy' }]">
					MTProxy
				</router-link>
				<router-link :to="{ name: 'UserHealthCheck' }" :class="['nav-link', { active: $route.name === 'UserHealthCheck' }]">
					Health Check
				</router-link>
				<button @click="logout" class="nav-link nav-link-logout">Logout</button>
			</nav>
		</template>
		<template #body>
			<slot></slot>
		</template>
	</RegisteredPageLayout>
</template>

<script>
import RegisteredPageLayout from '../_PageLayout.vue'

export default {
	name: 'UserPageLayout',
	components: {
		RegisteredPageLayout
	},
	props: {
		loading: {
			type: Boolean,
			required: true
		},
		error: {
			type: String,
			default: ''
		}
	},
	methods: {
		logout() {
			localStorage.removeItem('authToken')
			localStorage.removeItem('userEmail')
			this.$router.push({ name: 'Login' })
		}
	}
}
</script>

<style>
</style>

